// Components
import { requestPayoutApi } from './common';

// Types
import type { InvoiceHistory } from '../types/invoice-history.model';
import type { InvoiceDetails } from '../types/invoice-details.model';

// GET
export const history = ({ id, skip, sortings, take }): Promise<{ invoicesHistory: InvoiceHistory }> =>
  requestPayoutApi({
    api: `/api/shops/${id}/invoices/history?skip=${skip}&take=${take}&sortings=${sortings}`,
    authorized: true,
    method: 'GET'
  });

export const details = ({ id }): Promise<{ invoiceDetails: InvoiceDetails }> =>
  requestPayoutApi({ api: `/api/shops/invoices/${id}`, authorized: true, method: 'GET' });

export const generateInvoiceToken = ({
  startDate,
  endDate,
  shopId
}: {
  startDate: Date;
  endDate: Date;
  shopId?: number;
}): Promise<{ token: string }> =>
  requestPayoutApi({
    api: '/api/invoices/token',
    authorized: true,
    method: 'POST',
    body: {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      shopId: shopId ?? null
    }
  });

export const sendToPeppol = ({ invoiceId }: { invoiceId: number }): Promise<void> =>
  requestPayoutApi({
    api: `/api/invoices/send-to-peppol`,
    authorized: true,
    method: 'POST',
    body: {
      invoiceId: invoiceId
    }
  });
